export abstract class FilterObject<T> {
  field: any;
  values: Array<T>;
  displayName: string;

  constructor() {
    this.values = new Array<T>();
  }

  abstract doFilter(itemToFiltre : T, field : any , values : any) : boolean;
  abstract filter(itemToFiltre : T) : boolean;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/filter/filters/filter-object.ts